"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const operators_1 = require("rxjs/operators");
const api_1 = require("../notification/api");
const error_debouncer_operator_1 = require("../error-debouncer-operator");
class TemporaryErrorNotification {
    constructor(notificationService, options) {
        this.notificationService = notificationService;
        this.options = options;
    }
    enable(input, options) {
        const temporaryErrors$ = input
            .pipe(operators_1.filter(x => ['executed', 'retry', 'executed-with-custom-result'].indexOf(x.type) >= 0));
        const debouncedErrors$ = temporaryErrors$.pipe(operators_1.map(x => x.type === 'retry' ? error_debouncer_operator_1.debounceError(x.error) : error_debouncer_operator_1.debounceOk()), error_debouncer_operator_1.errorDebounceOperator({ debounceMs: this.options.debounceMs }));
        this.subscription = debouncedErrors$.subscribe({
            next: (item) => {
                switch (item.type) {
                    case 'error':
                        const payload = options.notificationFactory(item.error);
                        if (payload === null) {
                            break;
                        }
                        this.notificationService.show(api_1.createNotification(options.notificationName, payload, options.notificationId, 'pin', 'non-closeable'));
                        break;
                    case 'ok':
                        this.notificationService.hide(options.notificationId);
                        break;
                }
            }
        });
    }
    disable() {
        if (!this.subscription) {
            throw new Error('Coding error: enable not called');
        }
        this.subscription.unsubscribe();
        this.subscription = undefined;
    }
}
exports.TemporaryErrorNotification = TemporaryErrorNotification;
//# sourceMappingURL=temporary-error-notification.js.map